export const config = {
  title: 'South North Landscaping LLC | Landscaping Services in Charlotte, NC',
  meta: {
    description:
      'South North Landscaping LLC offers top-quality landscaping services for residential and commercial properties in Charlotte, NC. From lawn care to hardscaping, we transform outdoor spaces.',
    keywords: [
      'South North Landscaping',
      'Charlotte Landscaping Services',
      'Residential Landscaping',
      'Commercial Landscaping',
      'Lawn Care',
      'Hardscaping',
      'Irrigation Systems',
      'Mulch Installation',
      'Pressure Washing',
      'Drainage Solutions',
      'Paver Installation',
    ],
    author: 'South North Landscaping LLC',
    canonicalUrl: 'https://southnorthlandscaping.com/',
  },
  sections: {
    header: {
      businessName: 'South North Landscaping LLC',
    },
    sectionB: {
      heroTitle: 'Transform Your Landscape',
      heroSubtitle: 'Professional Landscaping Services in Charlotte, NC',
      learnAboutText: 'Explore Our Services',
      phoneNumber: '9803499395',
      phoneLabel: '(980) 349-9395',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1324918160/photo/professional-gardener-trimming-hedge.jpg?s=612x612&w=0&k=20&c=zumBbqam7P2pNpoGMrca4RhZGWW7zfRDUDE2zqABJTs=',
      cardData: [
        {
          title: 'Residential Landscaping',
          description:
            'Enhance your home’s curb appeal with our comprehensive residential landscaping services.',
        },
        {
          title: 'Commercial Landscaping',
          description:
            'Create inviting commercial spaces with our expert landscaping solutions.',
        },
        {
          title: 'Irrigation Systems',
          description:
            'Ensure optimal hydration for your landscape with our efficient irrigation installations and repairs.',
        },
      ],
      description:
        'At South North Landscaping LLC, we are dedicated to transforming outdoor spaces through quality workmanship and exceptional service in Charlotte, NC.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'We offer a wide range of landscaping services to meet your residential and commercial needs.',
      cards: [
        {
          title: 'Mulch Installation',
          description:
            'Protect your plants and enhance soil health with our professional mulch installation services.',
          imageSrc: 'https://media.istockphoto.com/id/1218926706/photo/man-carrying-mulch-to-front-yard.jpg?s=612x612&w=0&k=20&c=eLp1e1MKM_jRAgcPfmgL6zAofvu-DE6sEgXdoPO33dQ=',
          imageAlt: 'Mulch Installation',
        },
        {
          title: 'Pressure Washing',
          description:
            'Restore the cleanliness and appearance of your outdoor surfaces with our pressure washing services.',
          imageSrc: 'https://media.istockphoto.com/id/2150556211/photo/half-of-the-stone-slabs-were-cleaned-with-a-high-pressure-cleaner-before-and-afterwards.jpg?s=612x612&w=0&k=20&c=N9GDsNEsJWYEQy8kiA0JhSauch92yD3i-0kGaHVRtT0=',
          imageAlt: 'Pressure Washing',
        },
        {
          title: 'Paver Installation',
          description:
            'Add elegance and functionality to your outdoor spaces with our expert paver installation.',
          imageSrc: 'https://media.istockphoto.com/id/2176727127/photo/preparing-to-install-a-new-sidewalk-curb-to-replace-the-old-one.jpg?s=612x612&w=0&k=20&c=kmlsgvIryEey5dPCUY3SDTuNT4qHwzTYThgRc5H7At8=',
          imageAlt: 'Paver Installation',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Aeration',
        'Retaining Walls',
        'Gutter Cleaning',
        'Pine Needle Installation',
        'Drainage Solutions',
        'Planting Services',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=340,fit=crop,q=95/AQEVVKnKw1F2MO7Z/20240125_162811-1-1-m6LrvwlR7GtlwelK.jpg',
        alt: 'South North Landscaping Team',
      },
      aboutText: [
        'South North Landscaping LLC is a Charlotte-based company committed to delivering high-quality landscaping services.',
        'Our experienced team takes pride in creating and maintaining beautiful outdoor spaces for both residential and commercial clients.',
      ],
    },
    sectionE: {
      profileImage: null, // Add profile image URL if available
      profileAlt: 'South North Landscaping Logo',
      businessName: 'South North Landscaping LLC',
      contact: {
        phone: '9803499395',
        phoneLabel: '(980) 349-9395',
        email: 'gaudgarcia92@gmail.com',
        website: 'https://southnorthlandscaping.com/',
        address: 'Charlotte, NC, USA',
      },
      socialMedia: {
        facebook: null, // Add Facebook URL if available
        instagram: null, // Add Instagram URL if available
        twitter: null, // Add Twitter URL if available
        linkedIn: null, // Add LinkedIn URL if available
        youtube: null, // Add YouTube URL if available
      },
    },
    sectionF: {
      address: 'Charlotte, NC, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3309.123456789!2d-80.843127!3d35.227087!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8856a1b2c3d4e5f6%3A0x123456789abcdef!2sCharlotte%2C%20NC%2C%20USA!5e0!3m2!1sen!2sus!4v1611234567890!5m2!1sen!2sus',
    },
  },
};

export default config;
